import { createAction } from './helpers';

export const toggleMenu = () => createAction('@menu/TOGGLE');

export type MenuActions = ReturnType<typeof toggleMenu>;
